"use strict";
//import { config } from "@/../config";

/* eslint-disable no-debugger */
export const cookiesHelper = {
    setCookie,
    getCookie
}

function setCookie( token, maxAge ) {
    //document.cookie = `token=${token};path='/';samesite=lax;secure;max-age=${maxAge}`
    document.cookie = `token=${token};path='/';samesite=lax;max-age=${maxAge}`
}

function getCookie(cname) {
    const name = cname + "="
    const ca = decodeURIComponent(document.cookie).split(';')

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return '';
}